export default __webpack_public_path__ + "static/media/thunderstorm.eb01dd98.ogg";